<template>
    <broadcast-card eyebrow="Στατιστικά αγώνα" title="Εξέλιξη σκορ">
        <score-evolution-chart :logs="logs" :team1="match.team1" :team2="match.team2" broadcast />
    </broadcast-card>
</template>

<script>
    import BroadcastCard from '@/components/BroadcastCard'
    import ScoreEvolutionChart from '@/components/ScoreEvolutionChart'

    export default {
        name: 'ScoreEvolutionScreen',
        components: {
            BroadcastCard,
            ScoreEvolutionChart
        },
        props: {
            match: {
                type: Object,
                default: () => ({})
            },
            logs: {
                type: Array,
                default: () => []
            }
        }
    }
</script>

<style scoped>
/* Broadcast size: taller than the chart's default match-page height */
::v-deep .score-evolution-chart {
    height: 52vh;
    max-height: none;
}
</style>
